import { cn } from '#/lib/utils';
import { HTMLProps } from 'react';

interface SkeletonProps extends HTMLProps<HTMLDivElement> {
  isLoading?: boolean;
}
export default function Skeleton({
  isLoading = true,
  className,
  children,
  ...props
}: SkeletonProps) {
  return isLoading ? (
    <div
      className={cn(
        'bg-slate-200 dark:bg-slate-600 rounded animate-pulse',
        className
      )}
      {...props}
    >
      &nbsp;
    </div>
  ) : (
    <>{children}</>
  );
}
interface SkeletonGroupProps extends HTMLProps<HTMLDivElement> {
  isLoading?: boolean;
  numElements?: number;
  itemProps?: SkeletonProps;
}
export function SkeletonGroup({
  numElements = 1,
  itemProps,
  isLoading = true,
  children,
  ...props
}: SkeletonGroupProps) {
  return isLoading ? (
    <div {...props}>
      {Array.from({ length: numElements }).map((_, i) => (
        <Skeleton key={i} {...itemProps} isLoading />
      ))}
    </div>
  ) : (
    <>{children}</>
  );
}
